import { render, staticRenderFns } from "./ExtDraggableFiles.vue?vue&type=template&id=2293a6a5&scoped=true&lang=pug"
import script from "./ExtDraggableFiles.vue?vue&type=script&lang=ts"
export * from "./ExtDraggableFiles.vue?vue&type=script&lang=ts"
import style0 from "./ExtDraggableFiles.vue?vue&type=style&index=0&id=2293a6a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2293a6a5",
  null
  
)

export default component.exports